<template>
  <div>
    <PersonalAdd v-if="pageType === pageConfig.personal.type" />
    <EnterpriseAdd v-else-if="pageType === pageConfig.enterprise.type" />
  </div>
</template>

<script>
import { PAGE_CONFIG } from './config'
import PersonalAdd from './personalAdd.vue'
import EnterpriseAdd from './enterpriseAdd.vue'

export default {
  data() {
    return {
      pageType: '',
      pageConfig: PAGE_CONFIG,
    }
  },
  methods: {
    initPageType() {
      const { path } = this.$route

      let pageType = ''
      if (path.includes(this.pageConfig.personal.type)) {
        pageType = this.pageConfig.personal.type
      } else if (path.includes(this.pageConfig.enterprise.type)) {
        pageType = this.pageConfig.enterprise.type
      }

      this.pageType = pageType
    },
  },
  created() {
    this.initPageType()
  },
  components: {
    PersonalAdd,
    EnterpriseAdd,
  },
}
</script>
